import { render, staticRenderFns } from "./OfferItem.vue?vue&type=template&id=0d92a532&scoped=true&"
import script from "./OfferItem.vue?vue&type=script&lang=js&"
export * from "./OfferItem.vue?vue&type=script&lang=js&"
import style0 from "./OfferItem.vue?vue&type=style&index=0&id=0d92a532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d92a532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d92a532')) {
      api.createRecord('0d92a532', component.options)
    } else {
      api.reload('0d92a532', component.options)
    }
    module.hot.accept("./OfferItem.vue?vue&type=template&id=0d92a532&scoped=true&", function () {
      api.rerender('0d92a532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/OfferItem.vue"
export default component.exports